import { TrendUp, TrendDown } from "@phosphor-icons/react";

export default function StatCard({ label, value, change, suffix = "", prefix = "", icon: Icon, tone = "default", testId }) {
  const toneColor =
    tone === "positive" ? "#10B981" :
    tone === "negative" ? "#EF4444" :
    tone === "accent"   ? "#D4AF37" :
    "#FFFFFF";

  return (
    <div
      data-testid={testId}
      className="relative overflow-hidden rounded-2xl p-5 transition-all duration-300 hover:-translate-y-0.5"
      style={{
        background: "linear-gradient(145deg, #1C1C22 0%, #16161A 100%)",
        border: "1px solid rgba(212,175,55,0.18)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.04)",
      }}
    >
      {/* Gold hairline top */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0, height: 2,
        background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.7), transparent)",
      }} />

      <div className="flex items-start justify-between mb-3">
        <div className="text-[10px] uppercase tracking-[0.25em] font-black" style={{ color: "#52525B" }}>
          {label}
        </div>
        {Icon && (
          <div className="w-8 h-8 rounded-md flex items-center justify-center"
            style={{ background: "rgba(212,175,55,0.08)", border: "1px solid rgba(212,175,55,0.18)" }}>
            <Icon weight="fill" className="w-4 h-4" style={{ color: "#D4AF37" }} />
          </div>
        )}
      </div>

      {/* Número grande — estilo broadcast */}
      <div className="font-sport font-black tracking-tight leading-none"
        style={{ fontSize: 36, color: toneColor }}>
        {prefix}{value}{suffix}
      </div>

      {change !== undefined && change !== null && (
        <div className="mt-2 flex items-center gap-1 text-xs font-semibold"
          style={{ color: change >= 0 ? "#10B981" : "#EF4444" }}>
          {change >= 0
            ? <TrendUp className="w-3.5 h-3.5" weight="bold" />
            : <TrendDown className="w-3.5 h-3.5" weight="bold" />}
          <span>{change >= 0 ? "+" : ""}{Number(change).toFixed(2)}%</span>
        </div>
      )}
    </div>
  );
}
